const playQueue = []; // Cola de reproducción global
let isPlaying = false; // Estado global para controlar si se está reproduciendo un audio
let audioPermissionGranted = false; // Bandera crítica para el permiso del navegador
let audioContext = null; // NUEVO: Instancia global de AudioContext para el desbloqueo

// El stub de Base64 se elimina ya que usaremos AudioContext.
// const SILENT_MP3_BASE64 = '...'; 

// ** URLs PÚBLICAS DE AWS S3 CONFIRMADAS **
const AUDIO_MAP = {
    'cliente_en_espera': 'https://osoriorepuestos.s3.us-east-1.amazonaws.com/2025/cliente_en_espera.ogg',
    'nuevo_mensaje': 'https://osoriorepuestos.s3.us-east-1.amazonaws.com/2025/new_message.ogg',
    'nuevo_pedido_recibido': 'https://osoriorepuestos.s3.us-east-1.amazonaws.com/2025/nuevo-pedido-recibido.ogg'
};


// Función para manejar la reproducción de un archivo de audio (Optimizado para Promise)
const playAudio = async (audioFile) => {
    if (!audioPermissionGranted) {
        console.warn("Audio no se puede reproducir: Permiso de usuario aún no concedido.");
        return;
    }

    try {
        const audio = new Audio(audioFile);
        isPlaying = true;

        // =================================================================
        // AÑADIDO: Listener para capturar errores de carga (CORS o 404)
        audio.onerror = (e) => {
            console.error(
                "[ERROR DE CARGA DE AUDIO]",
                "El navegador no pudo cargar el recurso. Causa más probable: CORS o URL incorrecta (404).",
                e
            );
            // Si falla la carga, liberamos el estado para que el siguiente audio pueda intentar reproducirse
            isPlaying = false;
            if (playQueue.length > 0) {
                const nextAudio = playQueue.shift();
                setTimeout(() => playAudio(nextAudio), 200);
            }
        };
        // =================================================================

        await audio.play();
        //(`[Audio] Reproducción iniciada: ${audioFile}`);

        // Manejar el fin del audio
        audio.onended = () => {
            isPlaying = false;

            if (playQueue.length > 0) {
                const nextAudio = playQueue.shift();
                // Pequeño retraso para evitar que los sonidos se superpongan
                setTimeout(() => playAudio(nextAudio), 200);
            }
        };

    } catch (error) {
        // Este catch captura errores de la promesa de 'play()' (ej. NotAllowedError)
        console.error("[ERROR DE REPRODUCCIÓN - Play Promise Falló]", error.message, `Archivo: ${audioFile}`);
        isPlaying = false;

        // Si falló, intentar procesar el siguiente en cola
        if (playQueue.length > 0) {
            const nextAudio = playQueue.shift();
            setTimeout(() => playAudio(nextAudio), 200);
        }
    }
};

/**
 * Función que solicita el permiso de audio al navegador.
 * DEBE ser llamada inmediatamente después de la primera interacción del usuario.
 * Utiliza AudioContext.resume() para el desbloqueo.
 */
export const initializeAudioPermission = () => {
    if (audioPermissionGranted) {
        //console.log('[Audio] Permiso ya concedido.');
        return;
    }

    //console.log('[Audio] Intentando desbloquear AudioContext...');

    // 1. Crear o reanudar AudioContext
    if (!audioContext) {
        // Aseguramos la compatibilidad con navegadores antiguos (webkit)
        const AudioContextClass = window.AudioContext || window.webkitAudioContext;
        if (!AudioContextClass) {
            console.error("Este navegador no soporta AudioContext.");
            return;
        }
        audioContext = new AudioContextClass();
    }

    // 2. Reanudar el contexto al primer gesto del usuario
    audioContext.resume()
        .then(() => {
            // Éxito: el navegador concedió el permiso
            audioPermissionGranted = true;
            //console.log("✅ ¡Permiso de audio concedido por interacción del usuario mediante AudioContext!");

            // 3. Si hay audios esperando en la cola, iniciamos la reproducción
            if (playQueue.length > 0 && !isPlaying) {
                //console.log(`[Audio] Procesando ${playQueue.length} audios en cola.`);
                const nextAudio = playQueue.shift();
                playAudio(nextAudio);
            }
        })
        .catch(error => {
            // Este catch maneja el fallo al reanudar
            console.error("❌ Fallo al obtener el permiso de audio al reanudar AudioContext.", error.message);
        });
};


/**
 * Función principal llamada por el listener de socket.
 */
export const playAudioNotification = (audioKey) => {
    const audioFile = AUDIO_MAP[audioKey];
    if (!audioFile) {
        console.warn(`Audio key "${audioKey}" no reconocido.`);
        return;
    }

    // 1. Si no hay permiso, solo añade a la cola.
    if (!audioPermissionGranted) {
        playQueue.push(audioFile);
        //console.log(`[Cola] Permiso no concedido. Audio '${audioKey}' añadido a la cola. Tamaño: ${playQueue.length}`);
        return;
    }

    // 2. Si ya hay algo reproduciéndose, añade a la cola.
    if (isPlaying) {
        playQueue.push(audioFile);
        //console.log(`[Cola] Audio '${audioKey}' añadido a la cola. Tamaño: ${playQueue.length}`);
        return;
    }

    // 3. Reproducir inmediatamente si hay permiso y nada en curso.
    playAudio(audioFile);
};
